module.exports = __webpack_public_path__ + "img/up_arrow.bedad069.svg";